import type { ItemListParams } from '../services/smr-admin';

export const ITEM_PICKER_PAGE_SIZE = 20;
export const ITEM_PICKER_MAX_PAGE_SIZE = 100;

// Exclusion is client-side, so the page grows by the excluded count to keep 20 eligible rows.
export const itemPickerParams = (search: string, excludedCount = 0): ItemListParams => ({
    search: search.trim() || undefined,
    per_page: Math.min(ITEM_PICKER_MAX_PAGE_SIZE, ITEM_PICKER_PAGE_SIZE + excludedCount),
});
